import React from 'react';
import { Search, LocateFixed, X } from 'lucide-react';
import { cn } from '../../lib/utils';

function Chip({ active, onClick, children, testid, color }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 text-sm font-semibold font-heading',
        'transition-colors duration-200 ease-out',
        active
          ? 'border-transparent bg-primary text-white shadow-soft'
          : 'border-slate-200 bg-white text-ink-soft hover:border-primary hover:text-primary'
      )}
    >
      {color && !active && (
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
      )}
      {children}
    </button>
  );
}

export default function FilterBar({
  query,
  setQuery,
  networks,
  activeNetwork,
  setActiveNetwork,
  neighborhoods,
  activeNeighborhood,
  setActiveNeighborhood,
  proximity,
  onProximity,
  locating,
}) {
  return (
    <div className="space-y-3">
      <div className="relative">
        <Search size={18} className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-ink-faint" />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar por líder, anfitrião, célula..."
          data-testid="cell-search-input"
          className="h-12 w-full rounded-full border border-slate-200 bg-white pl-11 pr-10 text-base text-ink placeholder:text-ink-faint transition-colors duration-200 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
        />
        {query && (
          <button
            onClick={() => setQuery('')}
            data-testid="cell-search-clear"
            className="absolute right-3 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-full bg-slate-100 text-ink-soft hover:bg-slate-200"
            aria-label="Limpar busca"
          >
            <X size={15} />
          </button>
        )}
      </div>

      <div className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 pb-1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0">
        <Chip active={proximity} onClick={onProximity} testid="filter-proximity">
          <LocateFixed size={15} className={locating ? 'animate-pulse' : ''} />
          {locating ? 'Localizando...' : 'Perto de mim'}
        </Chip>
        <Chip
          active={!activeNetwork}
          onClick={() => setActiveNetwork(null)}
          testid="filter-network-all"
        >
          Todas as redes
        </Chip>
        {networks.map((n) => (
          <Chip
            key={n.id}
            active={activeNetwork === n.id}
            onClick={() => setActiveNetwork(activeNetwork === n.id ? null : n.id)}
            testid={`filter-network-${n.id}`}
            color={n.color}
          >
            {n.name.replace('Rede ', '')}
          </Chip>
        ))}
      </div>

      <div className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 md:mx-0 md:flex-wrap md:overflow-visible md:px-0">
        <Chip
          active={!activeNeighborhood}
          onClick={() => setActiveNeighborhood(null)}
          testid="filter-neighborhood-all"
        >
          Todos os bairros
        </Chip>
        {neighborhoods.map((b) => (
          <Chip
            key={b}
            active={activeNeighborhood === b}
            onClick={() => setActiveNeighborhood(activeNeighborhood === b ? null : b)}
            testid={`filter-neighborhood-${b}`}
          >
            {b}
          </Chip>
        ))}
      </div>

    </div>
  );
}
